import React from 'react';

import { strings } from 'constants/strings';
import { ErrorPage } from 'pages/common/errors';

const NotFound: React.FC = () => {
  return (
    <ErrorPage message={strings.Site.PageNotFound}>
      <br />4<i className="bx bx-buoy bx-spin text-primary display-3" />4
    </ErrorPage>
  );
};

export default NotFound;
